import React from 'react';

/**
 * リリーストラック情報（著作者）
 */
export default function MusicAlbumInfoReleaseTrackAuthorView({
  music,
} : {
  music: {
    is_inst: number,
    music_lyric_writers: {
      name: string,
      name_en: string,
    }[],
    music_composers: {
      name: string,
      name_en: string,
    }[],
  },
}) {
  const compoundLyricWriterName = music.music_lyric_writers.map((musicLyricWriter) => musicLyricWriter.name).join(', ');
  const compoundLyricWriterNameEn = music.music_lyric_writers.map((musicLyricWriter) => musicLyricWriter.name_en).join(', ');
  const compoundComposerName = music.music_composers.map((musicComposer) => musicComposer.name).join(', ');
  const compoundComposerNameEn = music.music_composers.map((musicComposer) => musicComposer.name_en).join(', ');

  return (
    <ul className="song_details">
      {!music.is_inst && (
        <li>
          <span>作詞：</span>
          {compoundLyricWriterName}
          /
          {compoundLyricWriterNameEn}
        </li>
      )}
      <li>
        <span>作曲：</span>
        {compoundComposerName}
        /
        {compoundComposerNameEn}
      </li>
    </ul>
  );
}

